import OauthManager from "./OauthManager";
const OauthKit = {
  store: null,
  oauth_window: null,
  showSignup() {
    OauthManager.showWindow(true);
  },
  showLogin() {
    OauthManager.showWindow();
  },
  setStore(store) {
    this.store = store;
  },
  //really in minigames we dont use this method
  showProjectRegister() {
    if (!this.store) {
      throw new Error("we need store");
    }
    this.store.commit("global/showReg");
  },
  /**
   * just proxy to __GEM
   */
  detectAndDownload() {
    window.__GEM.detectAndDownload();
  },
  showVkSignin() {
    window.__GEM.showVkSignin();
  },
  showOkAuth() {
    window.__GEM.showOkAuth();
  },
};
export default OauthKit;
